import React, { memo, useCallback } from "react";
import { Link } from "react-router-dom";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Page } from "@shared/components";
import { AppRoute } from "@app/models/AppRoute";
import useAppDispatch from "@app/hooks/useAppDispatch";
import { ReactComponent as ArrowBack } from "@assets/svg/arrow_back.svg";
import { openDataRoomSetupDialog } from "@dataRoomSetup/store/ducks";

const useStyles = makeStyles((theme) => ({
  tile: {
    display: "block",
    background: theme.palette.background.paper,
    paddingBlock: theme.spacing(20),
    textAlign: "center",
    textTransform: "uppercase",
    textDecoration: "none",
    color: theme.palette.primary.main,
    fontSize: 30,
    fontWeight: theme.typography.fontWeightMedium,
    transition: "all ease-in .15s",
    "&:hover": {
      background: theme.palette.secondary.main,
      color: theme.palette.common.white,
      "&> svg": {
        color: theme.palette.common.white,
      },
    },
  },
  arrow: {
    transform: "rotate(180deg)",
    marginLeft: theme.spacing(8),
    color: theme.palette.info.main,
  },
}));

const AdministrationHome = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const dataRoomSetupClick = useCallback(
    (event) => {
      event.preventDefault();
      dispatch(openDataRoomSetupDialog());
    },
    [dispatch]
  );
  // const dataRoomSetupClick = (event:) => {
  //   event.preventDefault();
  //   dispatch(openDataRoomSetupDialog());
  // };

  return (
    <Page title="Administration">
      <Grid container direction="row" spacing={5}>
        <Grid item xs={4}>
          <Link className={classes.tile} to={AppRoute.AdministrationReports} data-testid="reports-link">
            Reports
            <ArrowBack className={classes.arrow} data-testid="reports-link-arrow" />
          </Link>
        </Grid>
        <Grid item xs={4}>
          <Link className={classes.tile} to={AppRoute.AdministrationImpersonate} data-testid="impersonation-link">
            Impersonate user
            <ArrowBack className={classes.arrow} data-testid="impersonation-link-arrow" />
          </Link>
        </Grid>
        <Grid item xs={4}>
          <Link to="" className={classes.tile} onClick={dataRoomSetupClick} data-testid="dataroom-setup-link">
            Data Room Setup
            <ArrowBack className={classes.arrow} data-testid="dataroom-setup-link-arrow" />
          </Link>
        </Grid>
      </Grid>
    </Page>
  );
};

export default memo(AdministrationHome);
